import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {
    missedIncomeForRegulationPerDay,
    payoutPerDayForRegulation,
    useLeaveStore,
    yearMonthKey,
    YearMonthRegulations
} from '@/stores/leave'
import { computed } from 'vue'
import { translate } from '@/helpers/translate'
import { formatMoney } from '../helpers/formatMoney'


export default /*#__PURE__*/_defineComponent({
  __name: 'YearMonthRegulationInfo',
  props: {
    regulationId: null,
    year: null,
    month: null,
    days: null,
    mom: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    regulationId: string
    year: number
    month: number
    days: YearMonthRegulations
    mom: boolean
};



const leaveStore = useLeaveStore()
const regulation = computed(() => leaveStore.regulations.find(reg => reg.id === props.regulationId))
const key = yearMonthKey(props.year, props.month)
const { t } = translate()

const sentence = computed(() => {
    const dailySalary = leaveStore.dailySalary(props.mom)

    if (dailySalary === null) {
        return
    }

    const payoutPerDay = payoutPerDayForRegulation(regulation.value!!, dailySalary)
    const missedIncomePerDay = missedIncomeForRegulationPerDay(regulation.value!!, dailySalary)
    const translation = props.mom ? 'payoutNormalAndMissingMom' : 'payoutNormalAndMissingPartner'

    return t(translation, {
        payoutPerDay: formatMoney(payoutPerDay),
        normalIncomePerDay: formatMoney(dailySalary),
        missedIncomePerDay: formatMoney(missedIncomePerDay),
    })
})

return (_ctx: any,_cache: any) => {
  return (__props.days[_unref(key)][__props.regulationId] > 0)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, _toDisplayString(_unref(t)(_unref(regulation)?.title)) + ": " + _toDisplayString(__props.days[_unref(key)][__props.regulationId]) + " days. " + _toDisplayString(_unref(sentence)), 1))
    : _createCommentVNode("", true)
}
}

})